// export const BASE_URL = 'http://127.0.0.1:8000/api/';
// export const IMAGE_URL = 'http://127.0.0.1:8000';
export const IMAGE_URL = 'https://rentalway.etmaan.org/backend/public';
export const BASE_URL = 'https://rentalway.etmaan.org/backend/public/api/';